// src/components/theme/ThemeRecIndicator.js

import React from 'react';
import { Circle, Group, Text } from 'react-konva';
import PropTypes from 'prop-types';
import CustomColorPicker from '../CustomColorPicker';
import styles from './styles.module.css';
import { clamp, snapToGridFn, boundDrag } from '../CanvasTools';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../ScreenProps';


export const ThemeRecIndicatorSettings = ({ element, updateElement, openColorModal }) => {
    // Handlers for updating properties
    const handleXChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            updateElement(element.id, 'x', newValue);
        }
    };

    const handleYChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            updateElement(element.id, 'y', newValue);
        }
    };

    const handleRadiusChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue) && newValue > 0) {
            updateElement(element.id, 'size', newValue);
        }
    };


    return (
        <div>
            {/* X Position */}
            <label>
                X Position:
                <input
                    className={styles.inputNumber}
                    type="number"
                    min="0"
                    max={SCREEN_WIDTH - 1}
                    value={element.x}
                    onChange={handleXChange}
                    style={{ marginLeft: '10px', width: '60px' }}
                />
            </label>

            {/* Y Position */}
            <label>
                Y Position:
                <input
                    className={styles.inputNumber}
                    type="number"
                    min="0"
                    max={SCREEN_HEIGHT - 1}
                    value={element.y}
                    onChange={handleYChange}
                    style={{ marginLeft: '10px', width: '60px' }}
                />
            </label>

            {/* Radius */}
            <label>
                Radius:
                <input
                    className={styles.inputNumber}
                    type="number"
                    min="5"
                    value={element.size}
                    onChange={handleRadiusChange}
                    style={{ marginLeft: '10px', width: '60px' }}
                />
            </label>

            {/* Color */}
            <CustomColorPicker
                label="Color"
                color={element.color}
                onChange={(value) => { updateElement(element.id, 'color', value); }}
            />


        </div>
    );
};

ThemeRecIndicatorSettings.propTypes = {
    element: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        size: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        rotation: PropTypes.number.isRequired,
    }).isRequired,
    updateElement: PropTypes.func.isRequired,
    openColorModal: PropTypes.func.isRequired,
};


const ThemeRecIndicator = ({
    element,
    selectedElement,
    setSelectedElement,
    updateElement,
    render,
    editAllowed,
    scale,
    snapToGridEnabled,
    gridSize
}) => {
    const { x, y, size, color, rotation } = element;

    // Handle dragging end to update position
    const handleDragEnd = (e) => {
        updateElement(element.id, 'x', Math.round(e.target.x()));
        updateElement(element.id, 'y', Math.round(e.target.y()));
    };

    // Handle click to select the element
    const handleClick = () => {
        setSelectedElement(element);
    };

    // Determine if this element is selected
    const isSelected = selectedElement && selectedElement.id === element.id;

    return (
        <Group
            x={x}
            y={y}
            draggable={!render && editAllowed}
            rotation={rotation}
            dragBoundFunc={(pos) => { return boundDrag(pos, scale, snapToGridEnabled, gridSize, SCREEN_WIDTH, SCREEN_HEIGHT, size, size) }}
            onClick={handleClick}
            onDragEnd={handleDragEnd}
            offsetX={0}
            offsetY={0}
        >
            <Circle
                radius={size}
                fill={color}
                stroke={!render ? "#1976d2" : "transparent"}
                dash={isSelected ? [1, 1] : [0, 0]}
                strokeWidth={0.5}
            />
        </Group>
    );
};

ThemeRecIndicator.propTypes = {
    element: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        size: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
    }).isRequired,
    setSelectedElement: PropTypes.func.isRequired,
    updateElement: PropTypes.func.isRequired,
    render: PropTypes.bool.isRequired,
};

export default ThemeRecIndicator;